import { lazy, Suspense } from 'react';

// Use loose typing because the downstream package's distributed types are broad and may not map cleanly here.
// We forward all props directly.
// Using 'any' intentionally for pass-through

const InnerJsonViewer = lazy<any>(() => import('@lio/json-viewer').then((m: any) => ({ default: m.JsonViewer })));

export const LazyJsonViewer = (props: any) => (
  <Suspense fallback={null}>
    <InnerJsonViewer {...props} />
  </Suspense>
);
